export const BOOK_INFO = [
  {
    src: require('@/imgs/index/position/00.png'),
    width: '10rem',
  },
  {
    src: require('@/imgs/index/position/01.png'),
    width: '9rem',
  },
  {
    src: require('@/imgs/index/position/02.png'),
    width: '9rem',
  },
  {
    src: require('@/imgs/index/position/03.png'),
    width: '8.7rem',
  },
  {
    src: require('@/imgs/index/position/04.png'),
    width: '8.69rem',
  },
  {
    src: require('@/imgs/index/position/05.png'),
    width: '8.69rem',
  },
  {
    src: require('@/imgs/index/position/06.png'),
    width: '8.69rem',
  },
  {
    src: require('@/imgs/index/position/07.png'),
    width: '8.6rem',
  },
  {
    src: require('@/imgs/index/position/08.png'),
    width: '9.6rem',
  },
  // {
  //   src: require('@/imgs/index/position/09.png'),
  //   width: '8rem',
  // },
  // {
  //   src: require('@/imgs/index/position/10.png'),
  //   width: '10rem',
  // },
];

export const NAV_INFO = [
  {
    id: 0,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/qwyj_n.png'),
    hIcon: require('@/imgs/index/position/qwyj_h.png'),
  },
  {
    id: 1,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/qygh_n.png'),
    hIcon: require('@/imgs/index/position/qygh_h.png'),
  },
  {
    id: 2,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/sglt_n.png'),
    hIcon: require('@/imgs/index/position/sglt_h.png'),
  },
  {
    id: 3,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/ldsn_n.png'),
    hIcon: require('@/imgs/index/position/ldsn_h.png'),
  },
  {
    id: 4,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/zxlw_n.png'),
    hIcon: require('@/imgs/index/position/zxlw_h.png'),
  },
  {
    id: 5,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/wxfh_n.png'),
    hIcon: require('@/imgs/index/position/wxfh_h.png'),
  },
  {
    id: 6,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/xxyj_n.png'),
    hIcon: require('@/imgs/index/position/xxyj_h.png'),
  },
  {
    id: 7,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/gysj_n.png'),
    hIcon: require('@/imgs/index/position/gysj_h.png'),
  },
  {
    id: 8,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/position/yzyl_n.png'),
    hIcon: require('@/imgs/index/position/yzyl_h.png'),
  },
];
